import { render, staticRenderFns } from "./history-affiliate-titular.vue?vue&type=template&id=fa733544"
import script from "./history-affiliate-titular.vue?vue&type=script&lang=js"
export * from "./history-affiliate-titular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports